import React from "react";

const suggestedReadingOrderHtml = String.raw`
<h1 style="color:white">SUGGESTED READING ORDER
</h1>

<h2 style="color: white"> Some like it...
</h2>

<p style="color: white">
The series are COLOR-CODED...Knightess of the Realm in <char style="color:blue; background-color:cyan">BLUE,</char> Prankster Prince in <char style="color:green; background-color:lime">GREEN,</char> Chromicles of Ilseador in <char style="color:gold; background-color:darkviolet">PURPLE,</char>
</p>
<p style="color: white">
Start at the top of your preferred column and go straight down!
</p>

<p style="color: white">
The Prankster Prince titles are tongue-in-cheek - NOT kid stories!
</p>

<table style="width:100%">
<tr>
<th style="color:red; background-color:pink">SWEET</th>
<th style="color:lime; background-color:red">SPICY</th>
<th style="color:gold; background-color:navy">DARK</th>
<th style="width:10%">Row</th>
</tr>

<!-- ROw 1 -->
<tr>
<th style="color:darkblue; background-color:cyan"><i>A Not-So-Sacrificial Maiden
<br/> <small>(standalone prequel)
<br/><a href="https://risingdragonbooks.com/books/KotR1">(Click here)</a></small></i></th>
<th style="color:blue; background-color:cyan"><i>The Secrets of Dragon Mountain
<br/> <small>(trilogy)
<br/><a href="https://risingdragonbooks.com/mini-series/The-SECRETS-of-DRAGON-MOUNTAIN">(Click here)</a></small></i></th>
<th style="color:cyan; background-color:darkviolet"><i>The Rebel Duchess
<br/> <small>(standalone)
<br/><a href="https://risingdragonbooks.com/books/CoI1">(Click here)</a></small></i></th>
<th style="width:10%">1</th>
</tr>

<!-- ROw 2 -->
<tr>
<th style="color:tomato; background-color:lightgreen"><i>... or start with the Prankster Prince!...
<br/><small><a href="https://risingdragonbooks.com/fiction#prankster-prince">(Click here)</a></small></i></th>
<th style="color:blue; background-color:cyan"><i>An Altogether-Curious Altercation
<br/> <small>(SDM Book 1)
<br/><a href="https://risingdragonbooks.com/books/KotR5-SDM1">(Click here)</a></small></i></th>
<th style="color:gold; background-color:darkviolet"><i>The Prydeen Prophecy Cycle
<br/> <small>(4 books)
<br/><a href="https://risingdragonbooks.com/fiction#chronicles-of-ilseador">(Click here)</a></small></i></th>
<th style="width:10%">2</th>
</tr>

<!-- ROw 3 -->
<tr>
<th style="color:green; background-color:lime"><i>Thony and the Much-Anticipated Adventure
<br/><small><a href="https://risingdragonbooks.com/books/PP1">(Click here)</a></small></i></th>
<th style="color:blue; background-color:cyan"><i>An All-Too-Obvious Choice
<br/> <small>(SDM Book 2)
<br/><a href="https://risingdragonbooks.com/books/KotR6-SDM2">(Click here)</a></small></i></th>
<th style="color:gold; background-color:darkviolet"><i>The King's Champion
<br/> <small>(PPC Book 1)
<br/><a href="https://risingdragonbooks.com/books/CoI2">(Click here)</a></small></i></th>
<th style="width:10%">3</th>
</tr>

<!-- ROw 4 -->
<tr>
<th style="color:tomato; background-color:lightgreen"><i>The Raven War Saga <br/> <small> (4 books)
<br/><a href="https://risingdragonbooks.com/fiction#prankster-prince">(Click here)</a></small></i></th>
<th style="color:blue; background-color:cyan"><i>An Entirely Rational(ized) Decision
<br/> <small>(SDM Book 3)
<br/><a href="https://risingdragonbooks.com/books/KotR7-SDM3">(Click here)</a></small></i></th>
<th style="color:gold; background-color:darkviolet"><i>The Pirate-King
<br/> <small>(PPC Book 2)
<br/><a href="https://risingdragonbooks.com/books/CoI3">(Click here)</a></small></i></th>  
<th style="width:10%">4</th>
</tr>

<!-- ROw 5 -->
<tr>
<th style="color:tomato; background-color:lightgreen"><i>Thony Goes Astray! <br/> <small> (in the Deep, Dark, and Dangerous Fairy Wood)<br/> (RWS Book 1)
<br/><a href="https://risingdragonbooks.com/books/PP2-R">(Click here)</a></small></i></th>  
<th style="color:yellow; background-color:skyblue"><i>The Wedding of the Season
<br/><small>(3 books)
<br/><a href="https://risingdragonbooks.com/mini-series/The%20Wedding%20of%20the%20Season">(Click here)</a></small></i></th>  
<th style="color:gold; background-color:darkviolet"><i>The Pale Sorceress
<br/> <small>(PPC Book 3)
<br/><a href="https://risingdragonbooks.com/books/CoI4">(Click here)</a></small></i></th>  
<th style="width:10%">5</th>
</tr>

<!-- ROw 6 -->
<tr>
<th style="color:tomato; background-color:lightgreen"><i>So You Want to Be a Hero? <small>
<br/> (RWS Book 2)
<br/><a href="https://risingdragonbooks.com/books/PP3-R">(Click here)</a></small></i></th>  
<th style="color:yellow; background-color:skyblue"><i>An All-Too-Easy Answer
<br/><small>(WoS Book 1)
<br/><a href="https://risingdragonbooks.com/books/KotRMain-4-WoS-1">(Click here)</a></small></i></th>  
<th style="color:gold; background-color:darkviolet"><i>The UnCaptive King
<br/> <small>(PPC Book 4)
<br/><a href="https://risingdragonbooks.com/books/CoI5">(Click here)</a></small></i></th>    
<th style="width:10%">5</th>
</tr>

<!-- ROw 6 -->
<tr>
<th style="color:tomato; background-color:lightgreen"><i>How Thony Stopped a War<small>
<br/> (and Saved a Friendship)
<br/> (RWS Book 3)
<br/><a href="https://risingdragonbooks.com/books/PP4-R">(Click here)</a></small></i></th>    
<th style="color:yellow; background-color:skyblue"><i>An Unreasonably-Traumatic Celebration
<br/><small>(WoS Book 2)
<br/> <char style="color:red">Coming in 2026</char></small></i></th>
<th style="color:red; background-color:mediumpurple"><i>The Heart of Ilseador
<br/> <small>(trilogy)
<br/><a href="https://risingdragonbooks.com/books/CoI6-HoI1">(Click here)</a></small></i></th>    
<th style="width:10%">6</th>
</tr>

<!-- ROw 7 -->
<tr>
<th style="color:blue; background-color:lime"><i>The Pathremiri Problem<small>
<br/> (2 books)
<br/><a href="https://risingdragonbooks.com/books/PP5-P">(Click here)</a></small></i></th>
<th style="color:yellow; background-color:skyblue "><i>An Unexpectedly-Exciting Evening
<br/><small>(WoS Book 3)
<br/> <char style="color:red">Coming in 2026</char></small></i></th>
<th style="color:red; background-color:mediumpurple"><i>A Lovely Mess
<br/> <small>(HoI Book 1)
<br/><a href="https://risingdragonbooks.com/books/CoI6-HoI1">(Click here)</a></small></i></th>  
<th style="width:10%">7</th>
</tr>

<!-- ROw reminder -->
<tr>
<th style="color:red; background-color:pink">SWEET</th>
<th style="color:lime; background-color:red">SPICY</th>
<th style="color:gold; background-color:indigo">DARK</th>
</tr>

<!-- ROw 8 -->
<tr>
<th style="color:blue; background-color:lime"><i>Diary of a <del style="text-decoration-style: double;">Runaway Prince</del> Bold Questing Hero<small>
<br/> (TPP Book 1)
<br/><a href="https://risingdragonbooks.com/books/PP5-P">(Click here)</a></small></i></th>  
<th style="color:goldenrod; background-color:cyan"><i><char style="color:red">Time to FILL IN some BACKSTORY...</char>
<br/>The Heir's Journey
<br/><small> (PREQUEL trilogy... follows <char style="color:darkblue">A Not-So-Sacrificial Maiden,</char> precedes <char style="color:blue">Secrets of Dragon Mountain)</char>
<br/><a href="https://risingdragonbooks.com/mini-series/The-HEIR%E2%80%99s-JOURNEY-Prequel-trilogy">(Click here)</a></small></i></th>
<th style="color:red; background-color:mediumpurple"><i>Piled Higher &amp; Deeper
<br/> <small>(HoI Book 2)
<br/><a href="https://risingdragonbooks.com/books/CoI-HoI2">(Click here)</a></small></i></th>
<th style="width:10%">8</th>
</tr>

<!-- ROw 9 -->
<tr>
<th style="color:blue; background-color:lime"><i>A Court of Mists &amp; Misadventures <small>
<br/> (TPP Book 2)
<br/><a href="https://risingdragonbooks.com/books/PP6-P">(Click here)</a></small></i></th>
<th style="color:goldenrod; background-color:cyan"><i>A Not-So-Simple Mission
<br/><small> (HJ Book 1)
<br/><a href="https://risingdragonbooks.com/books/KotR2-HJ1">(Click here)</a></small></i></th>
<th style="color:red; background-color:mediumpurple"><i>Assorted Proofs of Love &amp; Power
<br/> <small>(HoI Book 3)
<br/><a href="https://risingdragonbooks.com/books/CoI-HoI3">(Click here)</a></small></i></th>
<th style="width:10%">9</th>
</tr>

<!-- ROw 10 -->
<tr>
<th style="color:darkgoldenrod; background-color:springgreen"><i>Dragons &amp; Damage Control<small>
<br/> (?? books)
<br/> <char style="color:red">Book 1 premiers in 2026</char></small></i></th>
<th style="color:goldenrod; background-color:cyan"><i>An Entirely-Unexpected Revelation
<br/><small> (HJ Book 2)
<br/><a href="https://risingdragonbooks.com/books/KotR3-Kalapula-HJ2">(Click here)</a></small></i></th>
<th style="color:gold; background-color:indigo"><i>The Battle for Elendria
<br/> <small>(?? books)
<br/> <char style="color:red">Book 1 premiers in 2026</char></small></i></th>
<th style="width:10%">10</th>
</tr>

<!-- ROw 11 -->
<tr>
<th style="color:darkgoldenrod; background-color:springgreen"><i>A School for Pranks &amp; Dragons<small>
<br/> (DDC Book 1)
<br/> <char style="color:red">Coming in 2026</char></small></i></th>
<th style="color:goldenrod; background-color:cyan"><i>An All-Too-Surprising Homecoming
<br/><small> (HJ Book 3)
<br/><a href="https://risingdragonbooks.com/books/KotR4-HJ3">(Click here)</a></small></i></th>
<th></th>
<th style="width:10%">11</th>
</tr>

<!-- ROw reminder -->
<tr>
<th style="color:red; background-color:pink">SWEET</th>
<th style="color:lime; background-color:red">SPICY</th>
<th style="color:gold; background-color:indigo">DARK</th>
</tr>

<!-- ROw 12 -->
<tr>
<th style="color:darkblue; background-color:aqua"><i>Out of the Woods... Hopefully
<br/> <small>(standalone prequel)
<br/><a href="https://risingdragonbooks.com/books/KotRP-OotW">(Click here)</a></small></i></th>
<th style="color:green; background-color:deepskyblue"><i><char style="color:red">A bit more BACKSTORY...</char>
<br/>A Not-So-Peaceful Interlude
<br/><small> (2 books... follows <char style="color:blue">Secrets of Dragon Mountain)</char> and precedes <char style="color:yellow">Wedding of the Season)</char> </small></i></th>
<th style="color:cyan; background-color:darkviolet"><i>We're out of DARK for now (more is coming)... <small><char style="color:red">but you might try the SPICY column for now...</char></small></i></th>
<th style="width:10%">12</th>
</tr>

<!-- ROw 13 -->
<tr>
<th style="color:darkblue; background-color:aqua"><i>The Fall of Taridawil
<br/> <small>(standalone prequel)
<br/><a href="https://risingdragonbooks.com/books/KotRP-FoT">(Click here)</a></small></i></th>
<th style="color:green; background-color:deepskyblue"><i>
An Unfairly-Painful Situation
<br/><small> (NSPI Book 1)
<br/> <char style="color:red">Coming in 2026</char></small></i></th>
<th></th>
<th style="width:10%">13</th>
</tr>

<!-- ROw 14 -->
<tr>
<th style="color:darkblue; background-color:aqua"><i>Scaredy Cat
<br/> <small>(standalone prequel)
<br/><a href="https://risingdragonbooks.com/books/KotRP-SC">(Click here)</a></small></i></th>
<th style="color:green; background-color:deepskyblue"><i>
A Fairly-Friendly Family
<br/><small> (NSPI Book 1)
<br/> <char style="color:red">Coming in 2026</char></small></i></th>
<th></th>
<th style="width:10%">14</th>
</tr>

<!-- ROw 15 -->
<tr>
<th></th>
<th style="color:white; background-color:dodgerblue"><i>
We're out of SPICY for now (more is coming)...
<br/><small> <char style="color:pink">But you might try the SWEET or DARK columns for now...</char></small></i></th>
<th></th>
<th style="width:10%">15</th>
</tr>

<!-- ROw end -->
<tr>
<th style="color:red; background-color:pink">SWEET</th>
<th style="color:lime; background-color:red">SPICY</th>
<th style="color:gold; background-color:indigo">DARK</th>
</tr>
</table>
`;

function SuggestedReadingOrder() {
  return <div dangerouslySetInnerHTML={{ __html: suggestedReadingOrderHtml }} />;
}

export default SuggestedReadingOrder;